import { useMemo } from 'react'

import { participantPermissionObserver } from '@livekit/components-core'
import type { ParticipantPermission } from '@livekit/protocol'

import { useRoomContext } from '@/src/context'

import { useObservableState } from '@/src/hooks/internal'

type ParticipantPermissionWithAdmin = ParticipantPermission & {
  roomAdmin?: boolean
}
/**
 * The `useLocalParticipantPermissions` hook returns the local participant's permissions.
 *
 * @example
 * ```tsx
 * const { canPublish, canPublishData } = useLocalParticipantPermissions();
 * ```
 * @public
 */
export function useLocalParticipantPermissions(): ParticipantPermissionWithAdmin | undefined {
  const room = useRoomContext()
  const permissionObserver = useMemo(
    () => participantPermissionObserver(room.localParticipant),
    [room],
  )
  const permissions = useObservableState(permissionObserver, room.localParticipant.permissions)
  return permissions as ParticipantPermissionWithAdmin | undefined
}
